import React from 'react';
import { Link } from 'react-router-dom';
const slides = [
    {
        title: "Records",
        mobileText: "Record keeping on the go",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_qw0fkn.png"
    },
    {
        title: "Reports",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745110268/image_12_woc9ha.png"
    },
    {
        title: "Service providers",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745110369/image_38_rqoid5.png"
    },
    {
        title: "Resources",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_3_rnbzmi.png"
    },
    {
        title: "Contracts",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745110450/image_39_uz7bor.png"
      },
      {
        title: "Communities",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744548246/image_5_f9hriz.png"
      },
    {
        title: "--",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744568897/image_6_ef9oxy.png"
    },
    {
        title: "--",
        imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1744568897/image_6_ef9oxy.png"
    },
];

const SolutionsGrid = () => {
    return (
        <div className="relative bg-white md:py-8 py-4 px-4 md:px-20">
            <div className='md:px-10'>
                <div className='flex justify-between  '>
                    <h1 className="text-[14px] md:text-[36px] font-bold  text-[#FDBD26] md:mb-5">Experience Farmnet App</h1>
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744287925/Expand_down_hlf9gz.png"
                        alt="icon"
                        className="w-6 h-6 md:w-8 md:h-8"
                    />
                </div>
                <h1 className="text-[10px] md:text-[32px] font-normal md:mb-6 mb-2 text-black" style={{lineHeight:'1.10'}}>
                    Mobile app solutions for farming are designed to assist farmers in improving productivity, efficiency, and sustainability through the use of technology. Farmnet offers solutions for farm management, monitoring, and data analysis, Production improvement, Market access and payments
                </h1>
            </div>

            {/* Grid Layout for the Cards */}
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 md:gap-y-4 gap-y-2  gap-x-2 md:px-10">
                {slides.map((slide, index) => (
                    <Link to={`/experience${index + 1}`}>
                    <div
                        key={index}
                        className="bg-[#2E453D] w-full h-[110px] sm:w-[45%] md:w-[570px] md:h-[336px] rounded-md overflow-hidden relative cursor-pointer"
                    >
                        {/* Logo inside each card */}
                        <div className="absolute -top-3 left-2 w-[50px] h-[50px] md:w-[80px] md:h-[75px] z-10">
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
                                alt="Logo"
                                className="w-full h-full object-contain"
                            />
                        </div>

                        {/* Centered Image */}
                        <div className="flex justify-center items-center w-full h-full">
                            <img
                                src={slide.imageUrl}
                                alt={slide.title}
                                className="object-contain w-[20%] md:w-[24%]"
                            />
                        </div>

                        {/* Text Content */}
                        <div className="absolute bottom-2 md:left-4 left-2 right-4 text-left">
                            <p className="text-[#FDBD26] text-[8px] md:text-[25px] font-bold">{slide.title}</p>
                        </div>

                        {/* "Read More" Link on the Left */}
                        <div className="absolute bottom-0 right-0 bg-[#152C24] z-20 rounded-tl-[50px] flex items-center justify-evenly md:px-1 px-1 w-[50px] h-[15px] md:w-[150px] md:h-[40px]">

                                <div className='flex items-center space-x-1 md:space-x-1 md:mt-1 mt-0.5 md:ml-3 ml-1.5'> 
                                    <p className='text-[4px] md:text-[14px] text-white font-bold'>Read More</p>
                                    <img
                                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                                        alt="Expand"
                                        className="w-[10px] md:w-[25px] h-[15px] md:h-[30px] object-contain"
                                    />
                                </div>
                        </div>
                    </div>
              </Link>

                ))}
            </div>
            <div className=" md:px-10">
  <h1 className="text-[18px] md:text-[32px] font-bold mt-8 mb-4 text-black">
    Download App
  </h1>
  <div className="flex flex-row sm:space-x-6 space-x-2  items-center sm:space-y-0">
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_903_oqescj.png"
      alt="App Store"
      className="h-[30px] md:h-[75px] object-contain"
    />
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png"
      alt="Google Play"
      className="h-[30px] md:h-[75px] object-contain"
    />
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image-1_wdvhie.png"
      alt="QR Code"
      className="h-[30px] md:h-[75px] object-contain"
    />
  </div>
</div>
        </div>
    );
};

export default SolutionsGrid;
